const GHOSTBEATS_SUGGESTION_BOARD_URL = "https://ghostbeats.featurebase.app/";

export function suggestionBoardUrl(): string {
  return import.meta.env.VITE_FEATUREBASE_PORTAL_URL?.trim() || GHOSTBEATS_SUGGESTION_BOARD_URL;
}
